import { internalFetch } from './fetchHelper';
import { getBackendApiUrl, getBackendApiKey } from './runtimeEnv';

export type ITimezone = {
  name: string;
};

let loadedNames: Set<string> | null = null;

export const getTimezones = async (
  abortController: AbortController
): Promise<ITimezone[]> => {
  const code = getBackendApiKey();
  const result = await internalFetch(
    `${getBackendApiUrl()}/p/timezones${code ? `?code=${code}` : ''}`,
    'GET',
    abortController
  );
  const list: ITimezone[] = Array.isArray(result) ? result : [];
  loadedNames = new Set(list.map((timezone) => timezone.name));
  return list;
};

export const isValidTimeZone = (value: string) =>
  !!value && (loadedNames ? loadedNames.has(value) : true);

export const defaultTimeZone = () => 'UTC';
